/**
 * Frontend mirror of the backend's Qualifying rules
 * (peareasy-services `src/credits/metered/qualifying.ts`).
 *
 * A metered route only charges for a Qualifying call — one that actually draws
 * on the user's club — so only a Qualifying call may be refused up front.
 * Getting this wrong in the strict direction is the expensive mistake: it would
 * block a market-only build that costs nothing.
 *
 * The rules live here as named predicates rather than as inline comparisons at
 * each button, so a backend change lands in one place.
 */
/** Solving and squad-building charge only when the club pool is drawn on. */
export const usesClubPool = (pool) => pool === "club" || pool === "both";
/**
 * Whether one SBC solve is the chargeable kind.
 *
 * The pool is no longer picked per solve — `POST /sbcs/:id/solutions` runs
 * club, both and market together — so what decides it is whether there is a
 * club to read, the way web's `solvesWithClub` does. A Streamline solve has no
 * market-only mode to fall back on, so it always qualifies. The old pool
 * setting still counts while the settings screen can still set one.
 */
export const solveSbcQualifies = ({ isStreamline = false, clubPlayersCount = 0, playersFrom, }) => isStreamline || clubPlayersCount > 0 || usesClubPool(playersFrom);
/** Chain recommendations charge only for a player already on an evo path. */
export const usesEvoPath = (evoPathId) => evoPathId != null;
//# sourceMappingURL=qualifying.js.map